<script setup lang="ts">
import { TransitionRoot, TransitionChild, Dialog, DialogPanel } from '@headlessui/vue'
import { VIcon } from '@/modules/shared/components'

defineProps({
  modalStore: {
    type: Object,
    required: true,
  },
  has_footer: {
    type: Boolean,
    required: false,
    default: true,
  },
})
</script>

<template>
  <TransitionRoot appear :show="modalStore.state.active" as="template">
    <Dialog as="div" @close="modalStore.close" class="relative z-50">
      <TransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div
          class="fixed inset-0 top-1 bg-white bg-opacity-25 bg-gradient-to-tr from-white/0 via-white/30 to-gray-300/90"
        ></div>
      </TransitionChild>

      <div class="fixed inset-0 top-1">
        <div class="inset-0 mb-6 flex h-screen items-stretch justify-end">
          <TransitionChild
            as="template"
            enter="transition ease duration-500 transform"
            enterFrom="opacity-0 translate-x-12"
            enterTo="opacity-100 translate-x-0"
            leave="transition ease duration-300 transform"
            leaveFrom="opacity-100 translate-x-0"
            leaveTo="opacity-0 translate-x-12"
          >
            <DialogPanel
              class="dialog-panel-container flex h-full w-full max-w-lg transform flex-col bg-white shadow-xl ring-1 ring-black ring-opacity-5 transition-all"
            >
              <button @click="modalStore.close" class="mr-4 mt-4 flex justify-end"><VIcon name="X" /></button>
              <div class="main-div flex-grow overflow-y-auto px-6 pb-6 pt-3 text-gray-700">
                <slot name="main"></slot>
              </div>
              <div class="mb-10 border-t border-gray-100 px-6 pb-6 pt-6 md:mb-0" v-if="has_footer">
                <slot name="footer"></slot>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
